import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { useStrapiAuthContext } from "./StrapiV3Auth";

export const ColaboradoresContext = createContext({});

export function ColaboradoresProvider({ children }) {
  const [colaboradores, setColaboradores] = useState([]);
  const [loadedData, setLoadedData] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const { token } = useStrapiAuthContext();

  useEffect(() => {
    if (token) {
      setLoadedData(false);
      axios
        .get(`${process.env.REACT_APP_URL_API}/colaboradores?_limit=-1`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setColaboradores(res.data);
          setLoadedData(true);
        });
    }
  }, [token]);
  return (
    <ColaboradoresContext.Provider
      value={{
        colaboradores,
        loadedData,
        searchValue,
        setSearchValue,
      }}
    >
      {children}
    </ColaboradoresContext.Provider>
  );
}

export const useColaboradoresContext = () => useContext(ColaboradoresContext);
